import React from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';

import logo from "../../Images/company-logo.png";

import "./Header.css"

const Header = () => {
 

  const activeStyle = {
    fontWeight: "bold",
    color: "#0409a9"
  };

  return (
    <>
      <Navbar bg="light" variant="light" expand="lg" sticky="top">
        <Container fluid>
          <Navbar.Brand as={NavLink} to="/home">
            <img src={logo} alt="Healthcare" width="180" height="50" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center">
            <Nav className="me-auto fs-5 fw-bold">
              <Nav.Link as={NavLink} activeStyle={activeStyle} to="/home">
                Home
              </Nav.Link>
              <Nav.Link as={NavLink} activeStyle={activeStyle} to="/about">
                About
              </Nav.Link>
              <Nav.Link as={NavLink} activeStyle={activeStyle} to="/products">
                Our Products
              </Nav.Link>
              <Nav.Link as={NavLink} activeStyle={activeStyle} to="/gallery">
                Gallery
              </Nav.Link>
              <Nav.Link as={NavLink} activeStyle={activeStyle} to="/career">
                Career
              </Nav.Link>
              <Nav.Link as={NavLink} activeStyle={activeStyle} to="/contact">
                Contact
              </Nav.Link>
            </Nav>
            <Nav className="ms-auto">
              <Nav.Link href="tel:+91-7447454145" className="text-decoration-none me-3">
                <FontAwesomeIcon icon={faPhone} className="me-2 icon" />
                Call Us
              </Nav.Link>
              <Nav.Link href="https://www.facebook.com">
              <FontAwesomeIcon icon={faLinkedinIn} className="icon" />
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
